<template>
    <div>
         <div v-show='show_results' class='results-container' id='results_container'>
                <div class='search-results-title'>Search Results</div>
                <div class='number-of-results-text'>Showing {{products.length}} of {{total_product_count}} results</div>
            <div>
                <div class='search-results-container'>
                    <div v-for='product in products' :key='product'>
                        <SearchResultsCard :product='product' @click='productClick(product)'/>
                        <!-- <ProductCard :product='product' @updatedCartListener='updatedCartListener'/> -->
                    </div>  
                </div>
            </div>
            <div v-show='total_product_count > products.length' class='show-all-results-container'>
                <Button class='show-all-results-button' :text='"Show all results ("+total_product_count+")"' theme='dark' @click='showAllResults'/>
            </div>
        </div>
    </div>
</template>

<script>
import SearchResultsCard from '@/ecom/components/navigation/header/search/SearchResultsCard.vue';
import ProductCard from '@/ecom/components/products/ProductCard.vue';
import Button from '@/ecom/components/buttons/Button.vue';

export default {
    components: {SearchResultsCard, ProductCard, Button},
    props: ['show_results', 'products', 'total_product_count'],
    emits: ['productClickListener', 'showAllResultsListener'],
    methods:{
        productClick(product){
            this.$emit('productClickListener', product);
        },
        showAllResults(){
            this.$emit('showAllResultsListener')
        }
    }
}
</script>

<style lang="scss" scoped>
.results-container{
    display: flex;
    position: absolute;
    flex-direction: column;
    gap: 20px;
    z-index: 1;
    background-color: white;
    width: 100%;
    height: 700px;
    max-height: 800px;
    left: 0;
    overflow-y: auto;
    padding: 20px;
    z-index: 11;
    margin-top: 15px;

    @media(max-width: 768px){
        left: 0;
        margin-top: 20px;
        width: auto;
    }
}

.search-results-container{
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 0px 50px;
    justify-content: center;
    @media(max-width: 768px){
        padding: 0 20px;
    }
}

.number-of-results-text{
    margin-top: -10px;
    text-align: center;
}

.results-card{
    width: 350px;
    height: 220px;
    background-color: white;
    cursor: pointer;
    color: black;
}

.search-results-title{
    display: flex;
    justify-content: center;
    font-size: 2rem;
}

.show-all-results-container{
    display: flex;
    justify-content: center;
}

.show-all-results-button{
    width: 250px;
}
</style>